module.exports = __webpack_public_path__ + "assets/5713e40d271616213b12963f2755217f.mp3";